import { Badge, Text } from "@mantine/core";
import { IconTrendingDown, IconTrendingUp } from "@tabler/icons-react";
import op from "./OperatorDashboardView.module.css";

const TONE_CLASS = {
  green: op.toneGreen,
  blue: op.toneBlue,
  amber: op.toneAmber,
  coral: op.toneCoral,
  teal: op.toneTeal,
  orange: op.toneOrange,
  indigo: op.toneIndigo,
};

const SUMMARY_CARD_COUNT = 7;

const formatSummaryValue = (value, currency) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return String(value ?? "—");

  if (currency) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      maximumFractionDigits: currency === "INR" ? 0 : 2,
    }).format(numeric);
  }

  return numeric.toLocaleString("en-IN");
};

const TrendBadge = ({ trendPercent }) => {
  if (trendPercent == null || Number.isNaN(Number(trendPercent))) return null;

  const value = Number(trendPercent);
  const isPositive = value >= 0;

  return (
    <Badge
      size="xs"
      variant="light"
      color={isPositive ? "green" : "red"}
      leftSection={
        isPositive ? <IconTrendingUp size={12} /> : <IconTrendingDown size={12} />
      }
      className={op.summaryTrend}
    >
      {isPositive && value > 0 ? "+" : ""}
      {value}%
    </Badge>
  );
};

const OperatorSummaryCards = ({ cards = [], loading }) => {
  if (loading) {
    return (
      <div className={op.summaryGrid}>
        {Array.from({ length: SUMMARY_CARD_COUNT }).map((_, index) => (
          <div key={index} className={`${op.summaryCard} ${op.summaryCardLoading}`}>
            <Text size="xs" c="dimmed">
              Loading…
            </Text>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={op.summaryGrid}>
      {cards.map((card) => (
        <article
          key={card.key}
          className={`${op.summaryCard} ${
            card.lowBalanceAlert ? op.summaryCardAlert : ""
          }`}
        >
          <div className={`${op.summaryStrip} ${TONE_CLASS[card.tone] ?? op.toneBlue}`} />
          <div className={op.summaryBody}>
            <Text className={op.summaryLabel}>{card.label}</Text>
            <div className={op.summaryValueRow}>
              <Text className={op.summaryValue}>
                {formatSummaryValue(card.value, card.currency)}
              </Text>
              <TrendBadge trendPercent={card.trendPercent} />
            </div>
            {card.foot ? (
              <Text className={op.summaryFoot} component="p">
                {card.foot}
              </Text>
            ) : null}
            {card.lowBalanceAlert ? (
              <Badge size="xs" color="red" variant="light" className={op.summaryAlert}>
                Low balance
              </Badge>
            ) : null}
          </div>
        </article>
      ))}
    </div>
  );
};

export default OperatorSummaryCards;
